<template>
  <div>
    <div class="modal show fade modal-danger text-left" style="display: block;" v-if="show">
      <div class="modal-dialog modal-lg" style="max-width: 80%;">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">WithDrawl Request Details</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card">
              <div v-if="list.length" class="card-body table-responsive p-0  table-bordered">
                <table class="table table-head-fixed table-hover-animation text-nowrap">
                  <thead>
                  <tr>
                    <th>Comments</th>
                    <th>Status</th>
                    <th>Update By</th>
                    <th>Time/Date</th>
                    <th>Details</th>
                  </tr>
                  </thead>
                  <tbody>
                  <template  v-for="(row, index) in list">
                    <tr>
                      <td>{{ row.comments }}</td>
                      <td v-if="row.status == 0"><span class="text-primary">Pending</span></td>
                      <td v-else-if="row.status == 1"><span class="text-primary">Active</span></td>
                      <td v-else-if="row.status == 2"><span class="text-primary">Canceled</span></td>
                      <td v-else-if="row.status == 3"><span class="text-primary">Rejected</span></td>
                      <td v-else-if="row.status == 4"><span class="text-primary">Accepted</span></td>
                      <td>{{ row.updated_by_user.email + '/' + row.updated_by_user.first_name }}</td>
                      <td>{{ customFormatDateTime(row.created_at)}}</td>
                      <td>
                        <button type="button"
                                class="btn btn-sm btn-icon font-weight-bolder font-medium-1 rounded-circle btn-warning waves-effect waves-float waves-light"
                                data-toggle="collapse" :data-target="'#demo'+index" @click="accordionToShow  = index">
                          +
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td  class="hiddenRow " colspan="5">
                        <div class="collapse" :id="'demo'+index">
                          <div class="card-body">
                            <div class="card">
                              <div class="row pl-5 font-weight-bolder font-medium-2" >
                                <h6 v-for="(detailItem,detailIndex) in row.details" class="text-dark position-relative d-inline-block m-2">{{detailItem}}: <span class="text-info">{{detailIndex}}</span></h6>
                              </div>

                            </div>
                          </div>

                        </div>
                      </td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
              <div class="card-body text-center text-primary" v-else>
                No Details Avaliable
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-danger" data-dismiss="modal" @click="$emit('hide')">Close</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>

export default {
  props: ['show', 'data', 'index'],
  data() {
    return {
      list: [],
      accordionToShow : -1
      // showModal: false,
    }
  },
  mounted() {
    // this.list = this.data
  },
  methods: {
    setupData() {
    }
  },
  watch: {
    show() {
      this.list = this.data
    },
    detailType() {

    }
  }
}
</script>

<style scoped>
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}
</style>

